import { useDispatch, useSelector } from "noval";
import { useRouter } from "next/router";
import CustomImage from "@components/CustomImage";
import BtnBase from "@components/Buttons/BtnBase";
import useTranslation from "next-translate/useTranslation";
import { memberships } from "@components/MyAccount/ProfileCard";
import { buildClass } from "@utils/tag";
import { Text } from "@utils/helper";

const ProfileItem = ({ removeIndecator = false }) => {
  const { pathname, push } = useRouter();
  const { t } = useTranslation();
  const user = useSelector("user");
  const { dispatch } = useDispatch();
  const complete_kyc = user?.is_kyc_completed;
  const current_membership = user?.membership?.current;
  const fullName = `${user?.first_name} ${user?.last_name}`;
  const membership_icon = memberships?.[current_membership || 1];
  const isProfessional = (user?.upgrade_request_level?.value || 1) === 2;

  const handleProfileClick = () => {
    if (complete_kyc) {
      push("/my-profile");
    } else {
      dispatch({ kycOpen: true, openDrawer: false });
    }
  };

  return (
    <div
      className="ltr:pl-7 rtl:pr-7 focus:!outline-none"
      onClick={() => dispatch({ openDrawer: false })}
    >
      {pathname.includes("my-profile") && !removeIndecator && (
        <div className="absolute w-[5px] h-[59px] bg-[#FFFFFF] ltr:left-0 rtl:right-0 ltr:rounded-r-[50px] rtl:rounded-l-[50px]" />
      )}
      <div className="overflow-hidden max-w-[250px] flex flex-col gap-3 ">
        <div className="flex gap-4 items-center ">
          <div
            className="flex justify-center items-center relative cursor-pointer"
            onClick={handleProfileClick}
          >
            {!complete_kyc && (
              <div className="flex justify-center items-center !min-w-[52px] min-h-[52px] bg-gradient-to-br from-[rgba(255,255,255,.6)] rounded-full">
                <CustomImage
                  src="/images/global/Profile-line.png"
                  alt="incomplete icon"
                  className="w-[34px] h-[34px] min-w-[34px] min-h-[34px] rounded-full"
                  width={200}
                  height={200}
                  loading="lazy"
                />
              </div>
            )}
            {complete_kyc ? (
              <CustomImage
                src={membership_icon}
                alt={current_membership}
                className="w-16 h-16 min-w-16 min-h-16 rounded-full"
                style={{ boxShadow: "0px 0px 7px #0000001a" }}
                width={200}
                height={200}
                loading="lazy"
              />
            ) : null}
            {!complete_kyc ? (
              <CustomImage
                alt="danger alert"
                src="/images/global/danger-alert.svg"
                className="absolute bottom-[8px] w-[17px] ltr:right-[-3px] rtl:left-[-3px]"
                width={20}
                height={20}
                loading="lazy"
              />
            ) : null}
          </div>

          <div
            className="flex flex-col gap-3 cursor-pointer"
            onClick={handleProfileClick}
          >
            {complete_kyc ? (
              fullName
            ) : (
              <Text
                color="#FFFFFF"
                className="leading-[20px]"
                fontType="Expo_sim"
                size="16px"
                weight="500"
              >
                {t("reminder.not_complete")}
              </Text>
            )}
            {isProfessional && (
              <span
                className={buildClass(
                  "flex justify-center items-center w-fit font-normal",
                  "border-[.5px] border-[#FFFFFF73] rounded-[50px]",
                  "py-px px-1 text-[8px]"
                )}
              >
                {t("slide.invest_status")}
              </span>
            )}
          </div>
        </div>
        {!complete_kyc && (
          <BtnBase
            className={buildClass(
              "items-center justify-center !font-light",
              "!capitalize w-full !bg-transparent whitespace-nowrap",
              "bg-gradient-to-br from-[rgba(255,255,255,.2)]",
              "!rounded-[50px] !border-solid !border",
              "!border-[rgba(255,255,255,.3)]"
            )}
            onClick={handleProfileClick}
          >
            <Text
              color="#FFFFFF"
              size="13px"
              weight="400"
              fontType="Expo_bok"
              className="!top-px leading-normal"
            >
              {t("kyc.complete")}
            </Text>
          </BtnBase>
        )}
      </div>
    </div>
  );
};

export default ProfileItem;
